import { useEffect } from 'react'
import { createFileRoute, redirect, useRouter } from '@tanstack/react-router'
import { authService } from '@/auth/service'
import { useAuth } from '@/auth/use-auth'
import { useIdentityQuery } from '@/hooks/use-identity-query'
import { userApi } from '@/api/client'
import { ConsoleLayout } from '@/components/layout/console-layout'
import { AuthLayout } from '@/components/layout/auth-layout'
import { StatePanel } from '@/components/common/state-panel'
import { Button } from '@/components/ui/button'
import { useI18n } from '@/i18n'

export const Route = createFileRoute('/_console')({
  beforeLoad: async ({ location }) => {
    const auth = await authService.restore()
    if (auth.status === 'unsupported') throw redirect({ to: '/browser-gate' })
    if (auth.status === 'expired' || auth.status === 'changed-elsewhere') throw redirect({ to: '/session', search: { state: auth.status } })
    if (auth.status === 'anonymous') throw redirect({ to: '/login', search: { redirect: location.href } })
    if (auth.status !== 'authenticated') throw new Error('session_restore_unavailable')
  },
  component: ProtectedConsole,
  errorComponent: RestoreError,
  pendingComponent: () => <AuthLayout><StatePanel kind='loading' /></AuthLayout>,
})
function RestoreError() {
  const { locale } = useI18n()
  const router = useRouter()
  const auth = useAuth()
  return <AuthLayout><StatePanel kind='unavailable' description={locale === 'zh-CN' ? '身份服务暂不可用，无法确认当前会话。' : 'The identity service is unavailable. Your session could not be verified.'}>
    <Button disabled={auth.loading} onClick={async () => { await authService.restore({ force: true }); await router.invalidate() }}>{locale === 'zh-CN' ? '重试' : 'Retry'}</Button>
  </StatePanel></AuthLayout>
}
function ProtectedConsole() {
  const auth = useAuth()
  const router = useRouter()
  const account = useIdentityQuery('account', [], signal => userApi.account(signal))
  useEffect(() => {
    if (auth.status === 'expired' || auth.status === 'changed-elsewhere') void router.navigate({ to: '/session', search: { state: auth.status } })
    else if (auth.status === 'anonymous') void router.navigate({ to: '/login' })
    else if (auth.status === 'unsupported') void router.navigate({ to: '/browser-gate' })
  }, [auth.status, router])
  if (auth.status === 'recoverable-error') return <RestoreError />
  if (auth.status !== 'authenticated') return <AuthLayout><StatePanel kind='loading' /></AuthLayout>
  return <ConsoleLayout key={auth.epoch} displayName={account.data?.displayName}
    onSignOut={async () => { await authService.signOut(); await router.navigate({ to: '/login' }) }} />
}
